import { setMultipleProviderCookiesPreference } from './cookies.api';
import { setCookie } from '../utils/domUtils';
import { startProviders } from '../providers';
import {
  providerKeys,
  getCookiesPolicy,
  cookiesPolicyName,
} from './cookiesUtils';
import { CookiesProviderTypes } from './cookies.types';

export async function acceptCookies(
  afterCookieSetCallback: Function = () => {},
) {
  let needValidationKeys = [...providerKeys];
  const cookie = getCookiesPolicy();

  if (cookie) {
    const isNullProvider = (key: CookiesProviderTypes) => cookie[key] === null;
    needValidationKeys = needValidationKeys.filter(isNullProvider);
  }

  const userIsLogged = window.logged_in;
  if (userIsLogged) {
    await setMultipleProviderCookiesPreference(
      needValidationKeys,
      needValidationKeys.map(() => true),
    );
  } else {
    const newCookie = {
      accepted: true,
    };
    const setValueToProvider = (
      acc: { [key: string]: boolean },
      key: CookiesProviderTypes,
    ) =>
      Object.assign(acc, {
        [key]: needValidationKeys.includes(key) || cookie[key],
      });
    providerKeys.reduce(setValueToProvider, newCookie);
    setCookie(cookiesPolicyName, JSON.stringify(newCookie), '365');
  }

  startProviders();
  afterCookieSetCallback();
}
